import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import { Select, MenuItem } from "@mui/material";
import { callAPI } from "../../../axios";
import { setChainIdAction } from "../../../store/actions/GetChainId/SetChainIdActions";
import { useDispatch, useSelector } from "react-redux";
import { getChainIdLS, setChainIdLS } from "../../../utils/utils";
import { setViewTypeAction } from "../../../store/actions/GetViewType/SetViewTypeActions";
import { Autocomplete, TextField } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';

const SelectHotel = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation()
  const [hotelList, setHotelList] = useState([]);
  const [hotelListFlag, setHotelListFlag] = useState(false);
  const [lastSelectedHotel, setLastSelectedHotel] = useState(null);
  // const [chainId, setChainId] = useState("");
  const { control, watch, setValue } = useForm({
    defaultValues: {
      chainId: '',
    },
  });
  const selectedChainId = watch('chainId');
  const { hotelUpdateFlag } = useSelector((state) => state.updateMasterHotelReducer)
  const disableHotel = ((props?.userRoleCode === "ROLE_SUPER_ADMIN" && location?.pathname === "/hms/ConfigurationNewHotel") || location?.pathname === "/hms/DefaultConfig" || location?.pathname === "/hms/PartnerConfiguration" ||
    location?.pathname === "/hms/RoomTypeConfiguration" || location?.pathname === "/hms/UtilityServiceConfiguration" || location?.pathname === "/hms/fetchcdsndetails" ||
    location?.pathname === "/hms/userList" || location?.pathname === "/hms/createEditUser" || location?.pathname === "/hms/roles" || location?.pathname === "/hms/rolesPermissions" ||
    location?.pathname === "/hms/userPrivilege" || location?.pathname === "/hms/SatelliteChannelMapping" || location?.pathname === "/hms/editUser" || location?.pathname === "/hms/pending-approvals" ||
    location?.pathname === "/hms/edit-role" || location?.pathname === "/hms/create-role" || location?.pathname === "/hms/myAccount" || location?.pathname === "/hms/changePassword" ||
    location?.pathname === "/hms/APKProviderConfiguration" || location?.pathname === "/hms/SoftwareStackDetails" || location?.pathname === "/hms/Dashboard/Hotels_Dashboard" || location?.pathname === "/hms/WhitelistDomain" ||
    location.pathname === "/hms/Dashboard/Automode_Dashboard" || location.pathname === "/hms/Dashboard/AssetManagement_Dashboard"

  )
  useEffect(() => {
    // console.log("hotelUpdate",getChainIdLS())
    callAPI(`master?type=HOTELS`, "GET")
      .then((response) => {
        setHotelList(response.data);
        setHotelListFlag(true);
        const selectedMasterHotel = response?.data?.filter((item) => item.code === getChainIdLS());
        let viewType = response?.data?.filter((item) => item.code === getChainIdLS());
        if (selectedMasterHotel?.length) {
          setValue('chainId', getChainIdLS());
        }
        else {
          if (response.data?.length) {
            setValue('chainId', response.data[0].code);
          }
        }
        if (viewType?.length) {
          dispatch(setViewTypeAction(viewType[0]?.viewType));
        }
        else {
          if (response.data?.length) {
            dispatch(setViewTypeAction(response.data[0].viewType));
          }
        }
      })
      .catch((error) => console.warn(error));
  }, [hotelUpdateFlag]);

  const initialRender = useRef(true)
  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false
    }
    else {
      if(selectedChainId){
      setChainIdLS(selectedChainId);
      let viewType = hotelList.filter((item) => item?.code === selectedChainId);
      dispatch(setChainIdAction({ selectedChainId, navSelectedhotelName: viewType}));
      dispatch(setViewTypeAction(viewType[0]?.viewType));
      if (viewType[0]?.viewType === "hotelApp" && props?.userRoleCode !== "ROLE_SUPER_ADMIN") {
        if (location?.pathname === "/hms/ConfigurationMasterApk") {

        }
        else {
          navigate("/hms/HotelOnboardingWizard");
        }
      }
      else if (viewType[0]?.viewType === "custom" && location?.pathname === "/hms/ConfigurationMasterApk") {
        navigate("/hms/ConfigurationNewHotel");
      }
    }
    }
  }, [selectedChainId]);

  useEffect(() => {
    if (hotelListFlag) {
      let hotelListItems = JSON.parse(
        JSON.stringify(hotelList)
      );
      let viewType = hotelListItems.filter((item) => item?.code === selectedChainId);
      dispatch(setChainIdAction({ selectedChainId, navSelectedhotelName: viewType }));
      dispatch(setViewTypeAction(viewType?.[0]?.viewType));
    }
  }, [hotelListFlag])

  return (
    <Controller
      name="chainId"
      control={control}
      render={({ field }) => (
        <Autocomplete
          options={hotelList}
          getOptionLabel={(option) => option?.name || ''}
          isOptionEqualToValue={(option, value) => option?.code === value?.code}
          value={
            hotelList.find((hotel) => hotel.code === field.value) || null
          }
          onChange={(_, selectedHotel) => {
            const hotelCode = selectedHotel?.code || '';
            field.onChange(hotelCode);
            if (selectedHotel) {
              setLastSelectedHotel(selectedHotel); // update last valid
            }
          }}
          onBlur={() => {
            const selectedHotel = hotelList.find(hotel => hotel.code === field.value);
            if (!selectedHotel && lastSelectedHotel) {
              setValue('chainId', lastSelectedHotel.code); // restore last valid
            }else{
              setValue('chainId', getChainIdLS());
            }
          }}
          renderOption={(props, option) => (
            <li {...props} key={option.code}>
              <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <div style={{ fontWeight: 'normal', fontSize: '14px' }}>
                  {option.name}
                </div>
                <div style={{ 
                  fontSize: '12px', 
                  color: '#666', 
                  marginTop: '2px' 
                }}>
                  {/* Add your additional text here */}
                  ({option.viewType==="custom"?"TP-HMS":"IHCL"})
                </div>
              </div>
            </li>
          )}
          disabled={disableHotel}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              className="select-project"
            />
          )}
        />

      )}
    />
  );
};

export default SelectHotel;
